import { useMemo } from 'react';

import { State } from '@/common/types';
import { useStatesQuery } from '@/modules/core/hooks';
import { AddressPayload } from  '@/modules/ExpressSetup/EditAddressModal/stores/useAddress.store.ts';
import { getFullAddress } from '@/utils/modifiers';

const DEFAULT_COUNTRY_NAME = 'US';

export const useGetOrgFullAddress = (address?: AddressPayload, isExpressSetupMode?: boolean) => {
  const { states } = useStatesQuery();
  const modifiedAddress = useMemo(() => {
    return {
      city: address?.city,
      line1: address?.street,
      line2: address?.street_2,
      zipcode: address?.zipCode,
      state: states?.find((state: State) => state.code === address?.state),
      country: {
        name: DEFAULT_COUNTRY_NAME,
        alpha2: '',
        alpha3: '',
      },
    };
  }, [address, states]);
  
  const fullAddress = useMemo(() => getFullAddress(modifiedAddress, isExpressSetupMode), [isExpressSetupMode, modifiedAddress]);
  return fullAddress;
};
